module.exports = __webpack_public_path__ + "static/media/en-check-remaining-traffic_1.7e5acf14.png";